import { timeEntriesPath, inspectionPath, workOrderPath } from 'routes';

export default ({ screen, screenId }) => {
  if (screen === 'inspection' && screenId) {
    return inspectionPath({ id: screenId });
  }
  if (screen === 'workOrder' && screenId) {
    return workOrderPath({ id: screenId });
  }
  return timeEntriesPath();
};
